var React = require('react');

function Diploma348px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M47 31.952h-3a1 1 0 1 1 0-1.998h2V1.988H2V30h20c.553 0 1 .401 1 .953 0 .551-.447 1.047-1 1.047H1c-.553 0-1-.496-1-1.047V.989A.999.999 0 0 1 1-.01h46c.553 0 1 .447 1 .999v29.964a1 1 0 0 1-1 .999zm-14-16.98c3.859 0 7 3.137 7 6.992 0 1.31-.369 2.533-1 3.582v11.4a1.002 1.002 0 0 1-1.515.856l-4.484-2.688-4.486 2.688a1.004 1.004 0 0 1-1.008.013.997.997 0 0 1-.507-.869v-11.4a6.926 6.926 0 0 1-1-3.582c0-3.855 3.141-6.992 7-6.992zm0 1.998c-2.757 0-5 2.241-5 4.994a5.003 5.003 0 0 0 5 4.994c2.757 0 5-2.241 5-4.994a5.003 5.003 0 0 0-5-4.994zm-.514 16.123a.997.997 0 0 1 1.03 0L37 35.182v-7.489a6.962 6.962 0 0 1-8 0v7.489l3.486-2.089zm-11.485-19.12a.999.999 0 1 1 0 1.998H11a.999.999 0 1 1 0-1.998h10.001zM6 8.979a.998.998 0 0 1 1-.998h34a.998.998 0 1 1 0 1.997H7c-.553 0-1-.447-1-.999z","key":1})]);
}

Diploma348px.displayName = "Diploma348px";

Diploma348px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 37.97"};

module.exports = Diploma348px;

Diploma348px.default = Diploma348px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/diploma-3-48px.svg
// module id = 1134
// module chunks = 0